import React, { useState } from'react';
import styled from '@emotion/styled';

import LoginModal from "components/pages/Login/PC/LoginModal";

interface HeaderPcProps {
  disable: boolean;
}
const HeaderPc:React.FC<HeaderPcProps> = ({ disable }) => {
  const [ showModal, setShowModal ] = useState(false);
  const handleGotoHomapage:React.MouseEventHandler<HTMLDivElement> | undefined = () => {
    window.location.href="https://photypeta.com"
  };

  const handleGotologin = () => {
    // window.location.href="https://app.photypeta.com/login"
    // alert("모바일 환경에서 사용해 주세요.")
    setShowModal(true)
  }
    const closeModal = () => {
    if (showModal === true) return setShowModal(false);
  };
  
  return(
    <>
    <Container>
      <ImgContainer
        onClick={!disable ? undefined : handleGotoHomapage}
      >
        <LogoImg src='/images/logoImg2.png'/>
      </ImgContainer>
      <LogoutContainer
        onClick={handleGotologin}
      ><span>로그인</span></LogoutContainer>
    </Container>
    {showModal && <LoginModal showModal={showModal} closeModal={closeModal} />}
    </>
  )
};

export default HeaderPc;

const Container = styled.div`
  max-width: 1024px;
  width: 95%;
  height: 69px;
  
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: space-between; */
  margin: 0 auto;
`
const ImgContainer = styled.div`
  width: 118px;
  height: 25.62px;


  /* margin-left: 17px; */
`
const LogoImg = styled.img`
  width: 100%;
  cursor: pointer;
`;
const LogoutContainer = styled.div`
  margin-left: auto;
  margin-right: 22px;
  font-family: 'Pretendard'; 
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  white-space:nowrap ;
  color:#797979;
  background-color: white;
  cursor: pointer;
`;